export const deepClone = <T>(input: T) =>
  JSON.parse(JSON.stringify(input)) as T;
